import styled from "@emotion/styled";
import { Button, IconButton, Typography } from "@mui/material";
import { mediumMobile, mobile } from "commons/styled.components";
import { COLORS } from "utils/colors";

export const DialogContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.75rem 2.5rem 2.25rem;
  background: #ffffff;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.16);
  border-radius: 1rem;
  position: relative;
  min-width: 26rem;

  ${mobile(`
    padding: 2rem 1.5rem;
    min-width: 0;
  `)}

  ${mediumMobile(`
    padding: 1.5rem 1.25rem;
  `)}
`;

export const DialogCloseButton = styled(IconButton)`
  height: 1.75rem;
  width: 1.75rem;
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  color: #9a9a9a;
`;

export const IconBadge = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  background-color: ${COLORS.BRAND_LIGHT_BACKGROUND};
  color: ${COLORS.BRAND_DEFAULT_COLOR};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  svg {
    font-size: 1.75rem;
  }
`;

export const HeadingText = styled(Typography)`
  font-weight: 700;
  font-size: 1.4rem;
  color: #000000;
  text-align: center;
  margin-bottom: 0.75rem;

  ${mobile(`
    font-size: 1.5rem;
  `)}
`;

export const MessageText = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #6b6b6b;
  text-align: center;
  margin-bottom: 0.35rem;
`;

export const PointsText = styled.span`
  font-weight: 700;
  color: ${COLORS.BRAND_DEFAULT_COLOR};
`;

export const TimeText = styled.span`
  font-weight: 700;
  color: #000000;
`;

export const StartButtonWrapper = styled.div`
  width: 100%;
  margin-top: 1.75rem;
`;

export const StartButton = styled(Button)`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.6rem;
  background-color: ${COLORS.BRAND_DEFAULT_COLOR};
  color: #ffffff;
  font-weight: 600;
  font-size: 1rem;
  text-transform: none;
  box-shadow: none;

  :hover {
    background-color: ${COLORS.BRAND_SECONDARY_COLOR};
    box-shadow: none;
  }
`;
